module.exports = __webpack_public_path__ + "media/offers/ring-2-7f52e535.svg";